// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid, Row, Col } from 'react-bootstrap';

import StepHeaderBlock from './StepHeaderBlock';
import { Whitespace } from '../common';

import ListPlaceTips from '../../components/ListPlaceTips/ListPlaceTips';
import FormNav from '../common/FormComponents/FormNav';
import { observer } from 'mobx-react';
import AddressSelect from '../addresses/AddressSelect';

@observer
class Address extends Component {
  static propTypes = {
    store: PropTypes.object,
    nextPage: PropTypes.func,
  };

  handleSelectionChanged = addresses => {
    const { store } = this.props;
    store.addresses = addresses;
  };

  render() {
    const { store, nextPage } = this.props;

    const visited = store.groupsVisited.address;

    return (
      <Grid>
        <Row>
          <Col xs={12} sm={8} md={8} lg={8}>
            <StepHeaderBlock headerText="Where can your item be picked up from?" />
            <Whitespace smaller />

            <AddressSelect
              onSelectionChanged={this.handleSelectionChanged}
              selected={store.addresses}
            />

            <FormNav nextPage={nextPage} store={store} />
          </Col>
          <Col>
            <ListPlaceTips
              tips={[
                {
                  title: 'Requirements',
                  tips: [
                    'If your suite, trailer, apartment, etc. has a number, put it on the line labled "Apt, Suite, Bldg. (optional)".',
                  ],
                },
                {
                  title: 'Privacy',
                  tips: [
                    'Don’t worry we won’t give this address out. We will randomly drop a pin on our map within 1 mile of your address.',
                    "When you approve a rental you'll be able to enter any andress you agree upon for the excahnge.",
                  ],
                },
              ]}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Address;



// WEBPACK FOOTER //
// ./src/components_new/addListing/Address.js